import { computed, Ref } from 'vue'
import type { MultiselectOption } from '@ironsight/types'

const statusOptionsArray = [
  { text: 'Requested', value: 'Requested' },
  { text: 'Assigned To Pool', value: 'AssignedToPool' },
  {
    text: 'Assigned To Service Provider',
    value: 'AssignedToServiceProvider',
  },
  { text: 'Scheduled', value: 'Scheduled' },
  { text: 'Active', value: 'Active' },
  { text: 'Paused', value: 'Paused' },
  { text: 'Completed', value: 'Completed' },
  { text: 'Pending Approval', value: 'PendingApproval' },
  { text: 'Approved', value: 'Approved' },
  { text: 'Rejected', value: 'Rejected' },
  { text: 'Cancelled', value: 'Cancelled' },
]

export function useJobStatusFilter(): { options: Ref<MultiselectOption[]> } {
  const options = computed<MultiselectOption[]>(() =>
    statusOptionsArray.map((status) => ({
      label: status.text,
      value: status.value,
    })),
  )

  return { options }
}
